/**
 * @packageDocumentation
 * @module StockChartShared
 */
import { Injectable } from '@angular/core';
import { UnitConversionConfig } from '../stock-chart-shared-models/unitConversion_config';
import { isEmptyField } from '../stock-chart-shared-services/stock-chart-util.service';

@Injectable({
  providedIn: 'root'
})
export class StockChartUnitConversionService {
  MCMMAF = 0.0008107131821088457;
  MCMBCM =  0.001;
  MCMTMC = 1000;


  constructor() { }

  unitConversion(value, unitConversionConfig: UnitConversionConfig) {
    if (isEmptyField(unitConversionConfig.from) || isEmptyField(unitConversionConfig.to)) {
      return value;
    }
    if (isEmptyField(value)) {
      return null;
    }
    if (unitConversionConfig.from === unitConversionConfig.to) {
      return value;
    }
    const functionToGetCalled = `conversionBetween${unitConversionConfig.from}And${unitConversionConfig.to}`;
    return this[functionToGetCalled](value, unitConversionConfig);
  }


  conversionBetweenMCMAndMAF(value, unitConversionConfig: UnitConversionConfig) {
    if (unitConversionConfig.from === 'MCM') {
      return value * this.MCMMAF;
    } else {
      return value / this.MCMMAF;
    }
  }

  conversionBetweenMCMAndTMC(value, unitConversionConfig: UnitConversionConfig) {
    if (unitConversionConfig.from === 'MCM') {
      return value * this.MCMTMC;
    } else {
      return value / this.MCMTMC;
    }
  }

  conversionBetweenMCMAndBCM(value, unitConversionConfig: UnitConversionConfig) {
    if (unitConversionConfig.from === 'MCM') {
      return value * this.MCMBCM;
    } else {
      return value / this.MCMBCM;
    }
  }
}

